module.exports = __webpack_public_path__ + "static/media/ing4.ccc3eabc.jpg";